<template>
    <div class="border-b border-dashed dark:border-neutral-500 w-full flex justify-start animate-pulse">
        <div class="px-6 py-2 flex flex-col justify-center items-center w-12 lg:w-16">
            <div class="h-4 lg:h-6 w-4 lg:w-6 bg-gray-600 animate-pulse"></div>
        </div>
        <div class="whitespace-nowrap px-6 py-2 flex-grow">
            <div class="flex items-center">
                <div class="flex-shrink-0 mr-2 md:mr-3">
                    <div class="h-10 lg:h-12 w-10 lg:w-12 rounded-lg bg-indigo-300 animate-pulse"></div>
                </div>
                <div class="flex-grow w-20 md:w-auto flex flex-col">
                    <h1 class="h-4 bg-gray-600 animate-pulse"></h1>
                    <p class="mt-2 h-2 bg-gray-300 animate-pulse"></p>
                </div>
            </div>
        </div>
        <div class="flex flex-col justify-center items-center px-6 py-2">
            <div class="h-4 w-24 lg:w-40 bg-gray-300 animate-pulse"></div>
        </div>
        <div class="flex flex-col justify-center items-center px-6 py-2">
            <div class="h-4 w-24 lg:w-40 bg-gray-300 animate-pulse"></div>
        </div>
        <div class="flex flex-col justify-center items-center px-6 py-2">
            <div class="h-4 w-24 lg:w-40 bg-gray-300 animate-pulse"></div>
        </div>
        <div class="w-24 lg:w-40 px-6 py-2 flex flex-col justify-center items-center">
            <div class="flex">
                <div class="animate-pulse bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                    <icon-eye class="animate-pulse w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                </div>
                <div class="animate-pulse bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                    <icon-pen class="animate-pulse w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-pen>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconEye from '../icons/IconEye.vue'
import IconPen from '../icons/IconPen.vue'
export default {
    name: "student-tile-shimmer",
    components: { IconEye, IconPen, },
}
</script>